
import React from 'react'
const json = {
    admission_date:false,
    discharge_date: false,
    chief_complaint:false,
    primary_a:false,
    primary_b:false,
    breathing_managements:false,
    hr:false,
    pr:false,
    bp_d:false,
    bp_s:false,
    bt:false,
    sat:false,
    primary_c:false,
    active_bleeding:false,
    managements:false,
    inv_eFAST:false,
    inv_ekg:false,
    gcs_e:false,
    gcs_v:false,
    gcs_m:false,
    pupil_response:false,
    primary_e:false,
    spine_alignment:false,
    pr2:false,
    ng_og_tube:false,
    inv_p_cxr:false,
    abg:false,
    alcohol_history:false,
    medication:false,
    past_illness_pregnancy:false,
    events:false,
    last_meal:false,
    head_neck:false,
    heart_lungs:false,
    abdomen_pelvis:false,
    extremities:false,
    per_rectal_exam:false,
    neurologic:false,
    primary_diagnosis:false,
    other_problems:false,
    plan_of_managements:false,
    restriction_cspine_motion:false,
    airway_managements:false,
    fractures_deformities:'No',
    fractures_deformities_remark:false,
    urethral_cath:false,
    allergy:false,
    height: false,
    weight: false,
    ward:false,
    staff_id :false,
    resident_name :false,
    record_name :false,
    recode_code :false,
    history:false
}

export default json;
